
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[blogPostSlug]",
      function () {
        return require("private-next-pages/blog/[blogPostSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[blogPostSlug]"])
      });
    }
  